export var sizes = ["small", "medium", "large", "header"];
/* eslint-disable @typescript-eslint/ban-types */